export default __webpack_public_path__ + "static/media/abstract2.66ae5272.jpeg";